import React from "react";

const benefitItems = [
  {
    icon: "fa-cogs",
    title: "Save Time",
    description: "Automates resume parsing, candidate matching, and assessments",
    textWhite: true,
    color:"#fff",
    backgroundcolor:"#00a7ac"
  },
  {
    icon: "fa-globe",
    title: "Improve Hiring Quality",
    description: "AI-powered matching and evaluation",
    textWhite: false,
    color:"#00a7ac",
    backgroundcolor:"#fff"

  },
  {
    icon: "fa-cloud",
    title: "Increase Efficiency",
    description: "Centralized repository for jobs, candidates, and submissions",
    textWhite: false,
    color:"#00a7ac",
    backgroundcolor:"#fff"

  },
  {
    icon: "fa-folder",
    title: "Simplify & Management",
    description: "One platform for jobs, candidates, clients, vendors, and teams",
    textWhite: true,
    color:"#fff",
    backgroundcolor:"#00a7ac"


  },
];

const KeyBenefits = () => {
  return (
    <div className="features-area overflow-hidden bg-gray default-padding">
      {/* Fixed Shape */}
      <div className="fixed-shape shape left bottom">
        <img
          decoding="async"
          src="https://wpriverthemes.com/tandaelem/wp-content/uploads/2022/01/3-1.png"
          alt="Shape"
        />
      </div>

      <div className="container">
        <div className="row align-center">
          {/* Left Column */}
          <div className="col-lg-5 why-us mt-5">
            <h5>key benefits</h5>
            <h2>Empowering smart hiring, one match at a time. </h2>
            <p>
             Built to remove complexity, KnackHire redefines how you manage candidates, clients, and teams. It streamlines every step from parsing resumes to AI-driven evaluations, so you focus on what truly matters: finding the right talent. 
            </p>
          </div>

          {/* Right Column - Features Grid */}
          <div className="col-lg-7 features-box text-center">
            <div className="row">
              {benefitItems.map((item, index) => (
                <div className="col-lg-6 col-md-6 item-grid" key={index}>
                  <div className={`item ${index % 2 === 0 ? "mt-5" : "mb-3"}`} style={{color:`${item.color}`,backgroundColor:`${item.backgroundcolor}`}}>
                    <i className={`fa ${item.icon}`} style={{color:`${item.color}`,backgroundColor:`${item.backgroundcolor}`}}></i>
                    <h5 className={item.textWhite ? "text-white" : "benifit-heading"}>{item.title}</h5>
                    <p className={item.textWhite ? "text-white" : ""}>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
.site-heading h2 {
    display: inline-block;
    font-weight: 600;
    padding-bottom: 20px;
    margin-bottom: 0;
    position: relative;
    letter-spacing: 1px;
    line-height: 1.4;
    margin-top: 40px;
}
.site-heading h2::before {
    background: #00a7ac none repeat scroll 0 0;
    bottom: 0;
    content: "";
    height: 2px;
    left: 50%;
    margin-left: -25px;
    position: absolute;
    width: 40px;
}
.work-process-area .work-pro-items .item i {
    display: inline-block;
    color: #086AD8;
    font-size: 60px;
    margin-bottom: 30px;
}
.flaticon-select:before {
    content: "\f111";
}
.work-process-area .work-pro-items .item .item-inner::after {
    /* right: 0; */
    bottom: 0;
}
.work-process-area .work-pro-items .item {
    border: 1px solid #e7e7e7;
    padding: 50px 30px;
    background: #ffffff;
    position: relative;
    z-index: 1;
    overflow: hidden;
}
.work-process-area .work-pro-items .item::before, .work-process-area .work-pro-items .item::after {
    content: "";
    width: 0;
    height: 2px;
    position: absolute;
    transition: all 0.2s linear;
    background: #086AD8;
}
.work-process-area .work-pro-items .item .item-inner::before {
    left: 0;
    top: 0;
}
.work-process-area .work-pro-items .item .icon {
    position: relative;
}
.work-process-area .work-pro-items .item h5 {
    position: relative;
    z-index: 1;
    font-weight: 600;
    font-size: 18px;
}
.work-process-area .work-pro-items .item p {
    margin: 0;
}
.work-process-area .work-pro-items .item::after {
    left: 0;
    bottom: 0;
}
.work-process-area .work-pro-items .item i {
    display: inline-block;
    color: #00a7ac;
    font-size: 60px;
    margin-bottom: 30px;
}
.work-process-area .work-pro-items .item .icon {
    position: relative;
}
.work-process-area .work-pro-items .item .icon span {
    position: absolute;
    left: 15px;
    top: 0;
    font-size: 100px;
    z-index: -1;
    color: #f4f4f4;
    opacity: 0.9;
    font-weight: 900;
    color: transparent;
    -webkit-text-stroke: 2px #f4f4f4;
    line-height: 50px;
    font-family: sans-serif;
}
.site-heading h2::after {
    background: #ffffff  none repeat scroll 0 0 !important;
    bottom: 0;
    content: "";
    height: 2px;
    left: 50%;
    margin-left: 20px;
    position: absolute;
    width: 5px;
}
.work-process-area .single-item {
    margin-bottom: 30px;
}
.work-process-area .work-pro-items .item {
    border: 1px solid #e7e7e7;
    padding: 50px 30px;
    background: #ffffff;
    position: relative;
    z-index: 1;
    overflow: hidden;
    height: 290px;
}
.work-process-area .work-pro-items .item::before {
    right: 0;
    top: 0;
}
.work-process-area .work-pro-items .item::before, .work-process-area .work-pro-items .item::after {
    content: "";
    width: 0;
    height: 2px;
    position: absolute;
    transition: all 0.2s linear;
    background: #086AD8;
}
//     .features-area .item-grid:first-child .item:first-child, .features-area .item-grid:last-child .item:last-child, .features-area .item-grid .item:hover {
//     background: linear-gradient(90deg, rgb(16 171 153) 0%, rgb(9 126 125) 100%);
// }
.features-area .item h5 {
    font-weight: 600;
    font-size: 18px;
}
.default-padding, .default-padding-top, .default-padding-bottom, .default-padding-mx {
    position: relative;
    z-index: 1;
}
.bg-gray {
    background-color: #f3f7fd;
}
.overflow-hidden {
    overflow: hidden !important;
}
.features-area .fixed-shape {
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.5;
}
.features-area .fixed-shape {
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.5;
}
// .features-area .item-grid:first-child .item:first-child, .features-area .item-grid:last-child .item:last-child, .features-area .item-grid .item:hover {
//     background: linear-gradient(90deg, rgb(16 171 153) 0%, rgb(9 126 125) 100%);
// }
.features-area .item {
    padding: 50px 30px;
    background: #ffffff;
    border-radius: 8px;
    position: relative;
    z-index: 1;
    overflow: hidden;
}
.features-area .item > i {
    display: inline-block;
    font-size: 50px;
    margin-bottom: 25px;
    color: #086AD8;
    position: relative;
    z-index: 1;
}
h5{
    color: #0e2b3d;
    font-weight: normal;
    line-height: 1.2;
    font-family: 'Inter', sans-serif;
    letter-spacing: 0;
    margin: 0;
} 

.site-heading h2 {
    display: inline-block;
    font-weight: 600;
    padding-bottom: 20px;
    margin-bottom: 0;
    position: relative;
    letter-spacing: 1px;
    line-height: 1.4;
    margin-top: 40px;
}
.site-heading h2::before {
    background: #00a7ac none repeat scroll 0 0;
    bottom: 0;
    content: "";
    height: 2px;
    left: 50%;
    margin-left: -25px;
    position: absolute;
    width: 40px;
} 
`}</style>
    </div>
  );
};

export default KeyBenefits;
